import React, { useContext } from 'react';
import classnames from 'classnames';
import { ListerContext } from '../../listerContext';
import { MessagePropertiesContext } from '../../../../contexts/messageProperties';
import { ResetFiltersButtonLG } from './buttons/resetButton';
import FacetsCategory from './facetsCategory';
import styles from './facets.module.pcss';

function FacetsCategories(): React.ReactElement {
  const [{ breadcrumbs, facets }] = useContext(ListerContext);
  const isNoFiltersSelected = !breadcrumbs.length;
  const [formattedMessage] = useContext(MessagePropertiesContext);

  return (
    <div className={classnames(styles.facets, 'rolex-spacing-50')}>
      <div className="rolex-spacing-50">
        <div className="rolex-spacing-20">
          <span className="rolex-title rolex-title--push">
            {formattedMessage({ id: 'rolex.plp.facetsHeading', fallback: 'Filter your search' })}
          </span>
        </div>
        <ResetFiltersButtonLG isDisabled={isNoFiltersSelected} />
      </div>
      <ul>
        {facets.map((facet) => (
          <li key={facet.code} className={styles['facets-menu__menu-list-item']}>
            <FacetsCategory facet={facet} />
          </li>
        ))}
      </ul>
    </div>
  );
}

export default FacetsCategories;
